<!--<granit-app-loading></granit-app-loading>-->
<header *ngIf="aktualisFelhasznalo">
  <app-header></app-header>
</header>
<main>
  <div class="router-wrapper">
    <router-outlet *ngIf="aktualisFelhasznalo"></router-outlet>
  </div>
  <div id="recaptcha-landmark-wrapper"
       role="complementary"
       aria-label="Biztonsági ellenőrzés">
  </div>
</main>

